import { SAMPLE_PIPES } from '../const';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getPipes = async () => {
  const response = await fetch(SAMPLE_PIPES);
  const res = await response.json();
  return res;
};
